import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { ClientProfileRelationshipType } from '@/types/schema';
import { diagnostics } from '@/utils/diagnostics';
import {
  GRANTOR_RELATIONSHIP_COPY_MAP,
  GRANTOR_RELATIONSHIP_ITEMS,
  PRIMARY_CLIENT_RELATIONSHIP_COPY_MAP,
  PRIMARY_CLIENT_RELATIONSHIP_ITEMS,
} from '@/utils/relationshipCopy.constants';

function mapItemsToOptions(
  items: ClientProfileRelationshipType[],
  isPrimaryClientRelationship?: boolean
): SelectInputOption[] {
  // we don't currently support the full set of relationships that are defined for use in the
  // family tree
  const copyMap = isPrimaryClientRelationship
    ? PRIMARY_CLIENT_RELATIONSHIP_COPY_MAP
    : GRANTOR_RELATIONSHIP_COPY_MAP;
  return items.flatMap((v) => {
    const label = copyMap[v];
    if (!label) {
      diagnostics.error(`Missing copy map label for ${v}`);
      return [];
    }

    return {
      display: label,
      value: v,
    };
  });
}

export const GRANTOR_RELATIONSHIP_OPTIONS = mapItemsToOptions(
  GRANTOR_RELATIONSHIP_ITEMS
).slice(); // slice to make it non-readonly

export const PRIMARY_CLIENT_RELATIONSHIP_OPTIONS = mapItemsToOptions(
  PRIMARY_CLIENT_RELATIONSHIP_ITEMS,
  true
).slice(); // slice to make it non-readonly
